import React, { PureComponent } from 'react';
import { Select } from 'antd';
import Icd10CmCodeSelector from 'components/common/Icd10CmCodeSelector';
import Icd10PcsCodeSelector from 'components/common/Icd10PcsCodeSelector';
import PrescriptionSelector from 'components/common/PrescriptionSelector';
import AllergenSelector from 'components/common/AllergenSelector';
import PropTypes from 'prop-types';

export default class CdsCodeSelector extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    // eslint-disable-next-line react/require-default-props
    value: PropTypes.object,
  };

  static defaultProps = {
    onChange: () => undefined,
  };

  state = {
    codeSystem: '',
  };

  handleChangeCodeSystem = codeSystem => {
    const { onChange } = this.props;
    onChange({ codeSystem, code: '' });
    this.setState({ codeSystem });
  };

  handleChangeCode = code => {
    const { onChange } = this.props;
    const { codeSystem } = this.state;
    onChange({ codeSystem, code });
  };

  renderCodeSelector() {
    const { value } = this.props;
    const { codeSystem } = this.state;

    const { code } = value || {};

    if (codeSystem === 'icd10Cm') {
      return <Icd10CmCodeSelector onChange={this.handleChangeCode} value={code} />;
    }
    if (codeSystem === 'icd10Pcs') {
      return <Icd10PcsCodeSelector onChange={this.handleChangeCode} value={code} />;
    }
    if (codeSystem === 'rxTerm') {
      return <PrescriptionSelector onChange={this.handleChangeCode} value={code} />;
    }
    if (codeSystem === 'allergen') {
      return <AllergenSelector onChange={this.handleChangeCode} value={code} />;
    }
    return null;
  }

  render() {
    const codeSystems = {
      icd10Cm: 'ICD10-CM',
      icd10Pcs: 'ICD10-PCS',
      rxTerm: 'Prescription',
      allergen: 'Allergen',
    };

    return (
      <>
        <Select onSelect={this.handleChangeCodeSystem} allowClear placeholder="Code system">
          {Object.keys(codeSystems).map(key => (
            <Select.Option key={key}>
              <div id={`cds-option-${key}`}>{codeSystems[key]}</div>
            </Select.Option>
          ))}
        </Select>
        {this.renderCodeSelector()}
      </>
    );
  }
}
